import { useCallback, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import Drawer from "@mui/material/Drawer";
import CardMedia from "@mui/material/CardMedia";

import { userState } from "../interface/MainInterface";
import LeftMenu from "./LeftMenu";
import { appConfig } from "../config/Config";

interface propsType {
  userState: userState;
  open: boolean;
  winSize: string;
  selectedMenu: string;
  headerLarge: boolean;
  drawerWidth: number;
  contentMargin: number;
  largeDrawerWidth: number;
  handleDrawer: any;
  closeMobileDrawer: any;
  menuOver: any;
  menuOut: any;
}

const Header = (props: propsType, ref: any) => {
  let navigate = useNavigate();

  const LeftMenuRef: any = useRef();

  // 헤더 메뉴 버튼 클릭시 좌측 메뉴 활성/비활성화
  const handleDrawer = () => {
    props.handleDrawer();
  };

  useEffect(() => {
    return () => {};
  }, []);

  // 메뉴 클릭시 페이지 이동
  const move = useCallback(
    (loc: string) => {
      if (props.winSize === "xs") {
        // 모바일 모드일때는 메뉴 선택시 좌측메뉴를 최소화
        props.closeMobileDrawer();
      }
      // 페이지 이동
      if (loc === "/makePress") navigate("/myIngList"); // 작성중인 보도자료를 먼저 선택하도록
      else navigate(loc);
    },
    [navigate, props]
  );

  // 로그아웃
  const signOut = async () => {
    if (!window.confirm("로그아웃 하시겠습니까?")) return;
    window.localStorage.removeItem(appConfig.sessionName);
    await Auth.signOut();
    window.location.href = "/hartlogin";
  };

  const getLeftCount = () => {
    LeftMenuRef.current.getLeftCount();
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    getLeftCount,
  }));

  return (
    <Box sx={{ flexGrow: 1, position: "sticky", top: "0", zIndex: "700" }}>
      {/* 상단 고정메뉴 Component */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#ffffff",
          boxShadow: "none",
          borderBottom: "1px solid #dfe4ec",
        }}
      >
        {/* 좌측 메뉴 Drawer */}
        <Drawer
          sx={{
            width: props.drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: props.drawerWidth,
              boxSizing: "border-box",
              overflowY: "auto",
              overflowX: "hidden",
              backgroundColor: "#2E3341",
              color: "#ffffff",
              transition: "width 0.5s",
            },
          }}
          anchor="left"
          open={props.open}
          variant={props.winSize === "xs" ? "temporary" : "persistent"}
          onMouseEnter={props.winSize === "xs" ? undefined : () => {
            if (!props.headerLarge) props.menuOver();
          }}
          onMouseLeave={props.winSize === "xs" ? undefined : () => {
            if (!props.headerLarge) props.menuOut();
          }}
          onClose={props.winSize === "xs" ? props.closeMobileDrawer : undefined}
          className="main-sidebar sidebar-dark-primary"
        >
          <LeftMenu
            ref={LeftMenuRef}
            userState={props.userState}
            drawerWidth={props.drawerWidth}
            largeDrawerWidth={props.largeDrawerWidth}
            selectedMenu={props.selectedMenu}
            move={move}
          />
        </Drawer>
        {/* 좌측 메뉴 Drawer */}
        {/* 상단 툴바 */}
        <Toolbar
          sx={{
            ml: `${props.contentMargin}px`,
            minHeight: "44px !important",
            height: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pl: "24px",
            pr: "22px !important",
            transition: "margin 0.5s",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawer}
            edge="start"
            sx={{
              width: "24px",
              height: "44px",
              ml: 0,
              mr: 0,
              p: 0,
              color: "#2e3341",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CardMedia
              component="img"
              image={"/images/side-toggle-button.png"}
              sx={{ width: "16px", height: "16px", objectFit: "contain" }}
            />
          </IconButton>
          <Box>
            <Button
              variant="text"
              onClick={signOut}
              sx={{
                minWidth: "auto",
                height: "44px",
                p: 0,
                color: "#9a9a9a",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: 1,
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#6b7280",
                },
              }}
            >
              로그아웃
            </Button>
          </Box>
        </Toolbar>
        {/* 상단 툴바 */}
      </AppBar>
    </Box>
  );
};

export default forwardRef(Header);
